//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useCallback, useContext, useEffect, useState } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles, CircularProgress } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../../system/firebase';
import { AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { fetchStripeInvoiceListByCustomer } from '../../common/services/paymentServices';
import { getFormattedPrice } from '../../common/textHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
import { getFormattedDate, getUserDateFormat } from '../../common/dateHelper';
// import _get from 'lodash/get';
import _map from 'lodash/map';
import _size from 'lodash/size';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        root: {},
        circularDivContainer: {
            textAlign: 'center',
            padding: '40px',
        },
        viewInvoiceLink: {
            paddingLeft: '20px',
        },
        flex: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '10px',
            paddingBottom: '5px',
            borderBottom: '1px solid lightgrey',
        },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes } = params;

    const defns = {};

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const TransactionHistory = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();

    const appContext = useContext(AppContext);
    const userDateFormat = getUserDateFormat(appContext);

    const { currentEmployer } = appContext;
    const stripeCusId = currentEmployer?.stripeCusId;

    // const layoutContext = useContext(LayoutContext);
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { propExample } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    const [invoiceList, setInvoiceList] = useState([]);
    const [isFetchingData, setIsFetchingData] = useState(false);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const loadTransactionHistory = useCallback(async () => {
        setIsFetchingData(true);
        const resp = await fetchStripeInvoiceListByCustomer({ stripeCusId });
        if (!resp || resp.error) {
            //TODO Handle error
            alert('Failed to fetch transaction history');
        } else {
            const list = resp.data?.data || [];
            setInvoiceList(list);
        }
        setIsFetchingData(false);
    }, [stripeCusId]);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    useEffect(() => {
        loadTransactionHistory();
    }, [loadTransactionHistory]);

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props });

    if (invoiceList.length > 0) {
        console.log(JSON.stringify(invoiceList[0]));
    }

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return isFetchingData ? (
        <div {...defns.circularDivContainer}>
            <CircularProgress size={50} />
        </div>
    ) : (
        <div {...defns.root}>
            <AfitdTypography variant="h6"> Total: {_size(invoiceList)}</AfitdTypography>
            <br />
            {/* <table></table> */}
            {/* {_map(invoiceList, invoice => {
                return (
                    <div {...defns.flex}>
                        <AfitdTypography variant="body">
                            {`Amt due: $${invoice.amount_due / 100} / 
                            Amt paid: $${invoice.amount_paid / 100} / 
                            Paid at: ${getFormattedDate(invoice.status_transitions?.paid_at * 1000)} 
                            `}
                        </AfitdTypography>
                        <AfitdTypography>
                            <a {...defns.viewInvoiceLink} href={invoice.hosted_invoice_url} target="_blank" rel="noopener noreferrer">
                                View invoice
                            </a>
                        </AfitdTypography>
                    </div>
                );
            })} */}
            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <b>Amount Paid</b>
                            </TableCell>
                            <TableCell>
                                <b>Date</b>
                            </TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {_map(invoiceList, (invoice, key) => {
                            return (
                                <TableRow key={key}>
                                    <TableCell component="th" scope="row">
                                        {getFormattedPrice(invoice?.amount_paid / 100)}
                                    </TableCell>
                                    <TableCell>{getFormattedDate(invoice.status_transitions?.paid_at * 1000, userDateFormat)}</TableCell>
                                    <TableCell>
                                        <a {...defns.viewInvoiceLink} href={invoice.hosted_invoice_url} target="_blank" rel="noopener noreferrer">
                                            View invoice
                                        </a>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};

export default TransactionHistory;
